import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

export function menu() {
    const menuResponsivo = document.querySelectorAll(".hasSubMenu");

    menuResponsivo.forEach((element) => {
        element.addEventListener(
            "click",
            function (e) {
                e.preventDefault();
                element.parentElement.classList.toggle("activeSubMenu");
            },
            false
        );
    });
}

export function menuMobile() {
    const btnMenuResponsivo = document.getElementById("menuMobile");
    const menu = document.getElementById("menu");
    // const menuBusca = document.getElementById('menuBuscaMobile');

    if (btnMenuResponsivo) {
        btnMenuResponsivo.addEventListener(
            "click",
            function () {
                this.classList.toggle("active");
                menu.classList.toggle("active");
                // menuBusca.classList.toggle("active");
            },
            false
        );
    }
}

const btn = document.getElementById("click-modal");
const modal = document.getElementById("modal");
const close = document.getElementById("closemodal");

btn.addEventListener("click", () => {
    modal.style.display = "flex";
});

close.addEventListener("click", () => {
    modal.style.display = "none";
});

// Fecha ao clicar fora
window.addEventListener("click", (e) => {
    if (e.target === modal) {
        modal.style.display = "none";
    }
});

// $(() => {
//     $("#topPhraseBox").addClass("active-box");
//     if (localStorage.getItem("activeBox")) {
//         $("#topPhraseBox").removeClass("active-box");
//     }
// });
// $("#closeTopPhrase").on("click", () => {
//     $("#topPhraseBox").removeClass("active-box");
//     localStorage.setItem("activeBox", "remove");
// });
